export default __webpack_public_path__ + "static/media/cvm.990dac7d.png";